'use strict'

import {Polymer} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {html} from '@polymer/polymer/lib/utils/html-tag.js'

import '@polymer/paper-fab/paper-fab.js'
import '@polymer/iron-icons/iron-icons.js'

Polymer({
  is: 'moskito-paper-fab-action',
  _template: html`
<style include="paper-material-styles">
:host {
  @apply --layout-horizontal;
  @apply --layout-center;
  @apply --layout-end-justified;
  margin-top: 15px;
  margin-right: 8px;
  /** For IE11: otherwise the label overlays the FAB */
  min-width: 270px;
}
.label {
  font-size: 0.8em;
  color: var(--paper-fab-speed-dial-action-label-color, white);
  background: var(--paper-fab-speed-dial-action-label-background, black);
  padding: 5px 10px;
  border-radius: 3px;
  margin-right: 20px;
}
.fab {
  --paper-fab-background: var(--paper-fab-speed-dial-action-background);
  --paper-fab-keyboard-focus-background: var(--paper-fab-speed-dial-action-keyboard-focus-background);
  position: relative;
  bottom: 0px;
  right: 0px;
}
.label,.fab {
  display: inline-block;
}
</style>
<div class="flex"><span class="label"><slot></slot></span></div>
<paper-fab class="fab" icon=[[icon]] mini></paper-fab>
  `,
  properties: {
    icon: String
  }
})
